export default class AttendeeService {
  constructor(baseUri) {
    this.baseUri = baseUri
  }

  async cancel(id, code, options) {
    const response = await fetch(`${this.baseUri}/booking/attendee/${id}/cancel/${code}`, {
      headers: {
        'Authorization': `Bearer ${options.accessToken}`
      },
      method: 'POST'
    })

    return response.ok
  }

  async create(attendee, options) {
    const response = await fetch(`${this.baseUri}/booking/attendee`, {
      body: JSON.stringify(attendee),
      headers: {
        'Authorization': `Bearer ${options.accessToken}`,
        'Content-Type': 'application/json'
      },
      method: 'POST'
    })

    if (!response.ok) {
      return null
    }

    return await response.json()
  }

  async delete(id, options) {
    const response = await fetch(`${this.baseUri}/booking/attendee/${id}`, {
      headers: {
        'Authorization': `Bearer ${options.accessToken}`
      },
      method: 'DELETE'
    })

    return response.ok
  }

  async find(id, options) {
    try {
      const response = await fetch(`${this.baseUri}/booking/attendee/${id}`, {
        headers: {
          'Authorization': `Bearer ${options.accessToken}`
        }
      })

      return await response.json()
    } catch (e) {
      return null
    }
  }

  async getAll(options) {
    const response = await fetch(`${this.baseUri}/booking/attendee`, {
      headers: {
        'Authorization': `Bearer ${options.accessToken}`
      }
    })

    return await response.json()
  }

  async update(id, attendee, options) {
    const response = await fetch(`${this.baseUri}/booking/attendee/${id}`, {
      body: JSON.stringify(attendee),
      headers: {
        'Authorization': `Bearer ${options.accessToken}`,
        'Content-Type': 'application/json'
      },
      method: 'PUT'
    })

    return response.ok
  }
}